import { Routes } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { LoadingComponent } from '../core/authentication/loading.component';
import { authErrorGuard } from '../core/guards/auth-error/auth-error.guard';

export const authRoutes: Routes = [
  {
    path: 'login',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: 'redirect',
    component: LoadingComponent,
    children: [
      {
        path: '',
        component: MsalRedirectComponent,
      },
    ],
  },
  {
    path: 'login-failed',
    loadComponent: () =>
      import('../core/authentication/login-failed.component').then((m) => m.LoginFailedComponent),
    canActivate: [authErrorGuard],
  },
  {
    path: 'not-invited',
    loadComponent: () =>
      import('../core/authentication/not-invited.component').then((m) => m.NotInvitedComponent),
    canActivate: [MsalGuard],
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('../core/authentication/not-found.component').then((m) => m.NotFoundComponent),
    canActivate: [MsalGuard],
  },
];
